export default (sendOptions) => sendOptions.isLoanDueDateTimeSelected() || sendOptions.isLostItemFeesSelected();
